export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const APP_ENV = process.env.REACT_APP_ENV || "dev";
